import { CollapseProductItem, type CollapseProductItemProps } from '@cart-ui/CollapseProductItem/CollapseProductItem'
import { type ItemWantToAdd, useHandleProductAddToCart } from '../../../../fp-b2b-shared/hooks/use-handle-product-add-to-cart'

export const MerchantCollapseProductItem = (props: CollapseProductItemProps) => {
  const { id, variation, currentQty } = props
  const { handleProductAddToCart } = useHandleProductAddToCart()

  const handleQuantityChange = (quantity?: number) => {
    const itemWantToAdd: ItemWantToAdd = {
      ...variation,
      delivery_class: variation.delivery_class,
      cartItemId: variation.variation_id,
      quantity,
    }
    handleProductAddToCart(itemWantToAdd)
  }

  return (
    <CollapseProductItem
      id={id}
      variation={variation}
      currentQty={currentQty}
      onQuantityChange={handleQuantityChange}
      showPreOrderChip
    />
  )
}
